import { render } from "./Index.vue?vue&type=template&id=06e1cadd&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=06e1cadd&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=06e1cadd&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e1cadd"]])

export default __exports__